import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

const fn = function ($scope, StateUtils, QuoteJumpToStepService, FlowValidationService, FLOW_VALIDATION_ERROR, FLOW_VALIDATION_WARN) {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;

    const updateErrors = () => FlowValidationService.getInvalidWizardSteps({level: FLOW_VALIDATION_ERROR});
    const updateWarns = () => FlowValidationService.getInvalidWizardSteps({level: FLOW_VALIDATION_WARN});

    /**
     * Method used by wizard ribbon set styles for active and visited steps in the wizard flow
     */
    function refreshStepsFn() {
        function setStepClasses(wizardSteps) {
            if (wizardSteps.length > 0) {
                const currentStateIdx = _.findIndex(wizardSteps, (step) => step.name === flowModel.currentStep.name);

                for (let stepIdx = 0; stepIdx < wizardSteps.length; stepIdx++) {
                    const step = wizardSteps[stepIdx];
                    const stepVisited = QuoteJumpToStepService.isStepIndexVisited(stepIdx, currentStateIdx);
                    const shouldMarkAsVisited = stepVisited || currentStateIdx === stepIdx;
                    const isInitialStep = stepIdx === 0;
                    const activeClass = currentStateIdx === stepIdx ? 'gw-current' : '';
                    const notVisitedClass = shouldMarkAsVisited || isInitialStep ? '' : 'gw-not-visited';
                    const visitedClass = shouldMarkAsVisited ? 'gw-visited' : '';
                    const allowedVisitClass = shouldMarkAsVisited ? '' : 'gw-not-allowed';
                    step.styleClass = `${activeClass} ${notVisitedClass} ${visitedClass} ${allowedVisitClass}`;
                    step.isDisabled = !shouldMarkAsVisited;
                }
            }
        }
        if (StateUtils.activeDataForState(true).model) {
            $scope.wizardSteps.length = 0;
            Array.prototype.push.apply($scope.wizardSteps, flowModel.steps);
            $scope.ribbonVisible = $scope.wizardSteps.length > 0;
            QuoteJumpToStepService.setRefreshFn(() => {
                return setStepClasses($scope.wizardSteps);
            });
            setStepClasses($scope.wizardSteps);
        }
    }

    ctrl.defineWatches = function () {
        $scope.$watch(updateErrors, (errorSteps) => {
            $scope.errorSteps = errorSteps;
        }, true);
        $scope.$watch(updateWarns, (warnSteps) => {
            $scope.warnSteps = warnSteps;
        }, true);
    };

    ctrl.init = function () {
        if (!flowModel) {
            return;
        }
        $scope.wizardSteps = [];
        $scope.warnSteps = [];
        $scope.errorSteps = [];
        $scope.ribbonVisible = false;
        refreshStepsFn();

        flowModel.addStepChangeListener(refreshStepsFn);

        const onStateTransition = (actionHandlerObject, promise) => {
            $scope.stateTransitionPromise = promise;

            try {
                let messageObject;
                if (_.isFunction(actionHandlerObject.msgs)) {
                    messageObject = actionHandlerObject.msgs();
                } else {
                    messageObject = actionHandlerObject.msgs;
                }
                $scope.stateTransitionMessage = messageObject.progress.message;
            } catch (ignore) { /* it's ok if there's no message */
            }
        };
        StateUtils.subscribeToStateTransitions(onStateTransition);

        $scope.$on('$destroy', () => {
            flowModel.removeStepChangeListener(refreshStepsFn);
            StateUtils.unsubscribeFromStateTransitions(onStateTransition);
        });
    };

    /**
     * Method used by wizard ribbon to move between steps.
     * @param {Object} step - selected step
     */
    ctrl.selectStep = function (step) {
        StateUtils.jumpToTheStep(step);
    };

    ctrl.stepLabel = function (step) {
        return step.label();
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'QuoteJumpToStepService', 'FlowValidationService', 'FLOW_VALIDATION_ERROR', 'FLOW_VALIDATION_WARN'];

export default fn;
